{
  /* eslint-disable */
}
import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import useInvoiceHook from "./useInvoice";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CURRENCY_SYMBOLS } from "./components/constant";
import SendToCustomerModal from "./sendToCustomerModal";
import { useEffect } from "react";

const InvoiceDetailsAdmin = () => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const { id } = useParams();
  const invoiceData = window.INVOICE;
  const company = window.COMPANY;
  const user = window.CURRENT_USER;
  const { FetchSingleInvoice, FetchInvoiceStatus } = useInvoiceHook();
  const { status } = FetchInvoiceStatus();
  const { invoice } = FetchSingleInvoice(id);

  const [menu, setMenu] = useState(false);
  const [attachmentsRefreshKey, setAttachmentsRefreshKey] = useState(0);

  const paymentOptions = [
    { id: 2, text: "Paid" },
    { id: 3, text: "Unpaid" },
    { id: 4, text: "Partially paid" },
    { id: 5, text: "Overdue" },
    { id: 6, text: "Cancelled" },
    { id: 7, text: "Refunded" },
    { id: 8, text: "Draft" },
  ];

  const formattedPaymentOptions = (paymentOptions) =>
    paymentOptions.map((option) => ({
      value: option.id,
      label: option.text,
    }));
  const [loading, setLoading] = useState(false);
  const handleStatusChange = (status) => {
    console.log("...", status);
    onSubmit(status);
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  function transformInvoicePayload(data) {
    return {
      invoice_number: data.invoice_number || "",
      reference_number: data.reference_number || "",
      customer_id: data.customer?.id || null,
      invoice_date: data.invoice_date || data.invoiceDate,
      due_date: data.due_date || data.dueDate,
      status: data.status?.value || 2,
      discount: data.discount || 0,
      notes: data.notes || "",
      terms: data.terms || "",
      signature_name: data.signature_name || invoice?.digital_signature_name,
      signature_image: data.signature_image || invoice?.digital_signature_image,
      invoice_products: (data.invoice_products || []).map((item) => ({
        product: item.product || null,
        quantity: item.quantity || 0,
        unit: item.unit || "",
        rate: item.rate || 0,
        discount: item.discount || 0,
      })),
    };
  }
  const values = transformInvoicePayload(invoice || {});
  const onSubmit = (newValue) => {
    console.log();
    fetch(`/invoice/${id}/edit-update/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ ...values, status: newValue?.value }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Invoice added successfully:", data);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error adding invoice:", error);
      });
  };
  console.log("invoice", invoice);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="card">
              <div className="card-body">
                <div className="page-header">
                  <div className="content-invoice-header">
                    <h5>Invoice Details</h5>
                    <style>{`
                      .list-btn {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 10px;
                        align-items: center;
                      }
                      .list-btn .btn {
                        margin-right: 0 !important;
                        white-space: nowrap;
                      }
                      @media (max-width: 768px) {
                        .content-invoice-header {
                          flex-direction: column;
                          align-items: flex-start !important;
                        }
                        .list-btn {
                          width: 100%;
                          margin-top: 15px;
                        }
                        .list-btn .btn {
                          flex: 1 1 auto;
                          min-width: 140px;
                        }
                      }
                      @media (max-width: 576px) {
                        .list-btn .btn {
                          flex: 1 1 100%;
                          width: 100%;
                        }
                      }
                    `}</style>
                    <div className="list-btn">
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#attachments_modal"
                        onClick={() => setAttachmentsRefreshKey((k) => k + 1)}
                      >
                        Attachments
                      </button>
                      <a
                        className="btn btn-primary"
                        href={`/invoice/${invoice?.id}/ledger/`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Invoice Ledger
                      </a>
                      <a
                        className="btn btn-primary"
                        href={`/invoice/${invoice?.id}/send-email/`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Invoice
                      </a>
                      { }
                      <a
                        className="btn btn-primary"
                        href={`/invoice/${invoice?.id}/download/`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download Invoice
                      </a>
                      {user?.user_role !== "customer" && (
                        <button
                          className="btn btn-primary"
                          disabled={loading}
                          // data-bs-toggle="modal"
                          // data-bs-target="#paynow_modal"
                          onClick={() => {
                            setLoading(true);
                            fetch(`/invoice/${invoice.id}/send-email/`, {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                "X-CSRFToken": document.cookie
                                  .split("; ")
                                  .find((row) => row.startsWith("csrftoken="))
                                  ?.split("=")[1],
                              },
                              credentials: "include",
                            })
                              .then((response) => response.json())
                              .then((data) => {
                                console.log(
                                  "Invoice added successfully:",
                                  data
                                );
                                alertify.set(
                                  "notifier",
                                  "position",
                                  "top-right"
                                );
                                alertify.success("Invoice sent to customer");
                                document
                                  .querySelector('[data-bs-dismiss="modal"]')
                                  ?.click();
                              })
                              .catch((error) => {
                                setLoading(false);
                                console.error("Error adding invoice:", error);
                              });
                          }}
                        >
                          Send to customer
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="cards">
                      <div className="card-bod">
                        <div className="card-table">
                          <div className="card-bod">
                            {/* Invoice Logo */}
                            <div className="invoice-item invoice-item-one">
                              <div className="row align-items-center">
                                <div className="col-md-6">
                                  <div className="invoice-logo">
                                    <img
                                      src={company?.company_icon}
                                      alt="logo"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6"></div>
                              </div>
                            </div>
                            {/* /Invoice Logo */}
                            {/* Invoice Date */}
                            <div className="invoice-item invoice-item-date">
                              <div className="row">
                                <div className="col-md-6">
                                  <p className="text-start invoice-details">
                                    Invoice Date<span>: </span>
                                    <strong>
                                      {" "}
                                      {invoice?.invoice_formatted_date}
                                    </strong>
                                  </p>
                                </div>

                                <div class="col-md-6">
                                  <p
                                    class="invoice-details"
                                    style={{
                                      textAlign: "end",
                                      marginTop: 5,
                                    }}
                                  >
                                    Invoice No<span>: </span>
                                    <strong>#{invoice?.invoice_number}</strong>
                                  </p>
                                  <p
                                    class="invoice-details"
                                    style={{ textAlign: "end", marginTop: 5 }}
                                  >
                                    Reference No<span>: </span>
                                    <strong>{invoice?.reference_number}</strong>
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* /Invoice Date */}
                            {/* Invoice To */}
                            <div className="invoice-item invoice-item-two">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="invoice-info">
                                    <strong className="customer-text-one">
                                      Invoiced To<span>:</span>
                                    </strong>
                                    <p className="invoice-details-two">
                                      {invoice?.customer?.company_name}
                                      <br />
                                      {invoice?.customer?.user?.full_name}
                                      <br />
                                      Customer ID <span>: </span>
                                      <strong>
                                        {invoice?.customer?.customer_code}
                                      </strong>
                                      <br />
                                      {
                                        invoice?.customer?.billing_address
                                          ?.address_line1
                                      }
                                      <br />
                                      {
                                        invoice?.customer?.billing_address
                                          ?.address_line2
                                      }
                                      <br />
                                      {
                                        invoice?.customer?.billing_address
                                          ?.country
                                      }
                                    </p>
                                  </div>
                                </div>
                                {/* <div className="col-md-6">
                                  <div className="invoice-info invoice-info2">
                                    <strong className="customer-text-one">
                                      Pay To<span>:</span>
                                    </strong>
                                    <p className="invoice-details-two">
                                      Walter Roberson
                                      <br />
                                      299 Star Trek Drive, Panama City,
                                      <br />
                                      Florida, 32405,
                                      <br />
                                      USA
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            {/* /Invoice To */}
                            {/* Invoice Item */}
                            <div className="invoice-item invoice-table-wrap">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="table-responsive">
                                    <table className="table table-center table-hover mb-0">
                                      <thead className="thead-light">
                                        <tr>
                                          <th>Product</th>
                                          <th>Quantity</th>
                                          <th>Unit</th>
                                          <th>Rate</th>
                                          <th>Amount</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {invoice?.invoice_products?.map(
                                          (item, key) => {
                                            return (
                                              <tr key={key}>
                                                <td
                                                  style={{
                                                    maxWidth: 300,
                                                    textWrap: "auto",
                                                  }}
                                                >
                                                  {item?.label}
                                                </td>
                                                <td>{item?.quantity}</td>
                                                <td>{item?.unit}</td>
                                                <td>
                                                  {
                                                    CURRENCY_SYMBOLS[
                                                    company?.currency_type
                                                    ]
                                                  }{" "}
                                                  {item?.rate}
                                                </td>
                                                <td>
                                                  {
                                                    CURRENCY_SYMBOLS[
                                                    company?.currency_type
                                                    ]
                                                  }{" "}
                                                  {item?.amount}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* /Invoice Item */}
                            <div className="col-lg-12 col-md-12">
                              <div className="invoice-total-card">
                                <div className="invoice-total-box">
                                  <div className="invoice-total-inner">
                                    <p>
                                      Sub Total{" "}
                                      <span>
                                        {
                                          CURRENCY_SYMBOLS[
                                          company?.currency_type
                                          ]
                                        }
                                        {invoice?.total_invoice_amount}{" "}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="invoice-total-inner">
                                    <p>
                                      Total Discount ({invoice?.discount_value}
                                      %)
                                      <span>
                                        {
                                          CURRENCY_SYMBOLS[
                                          company?.currency_type
                                          ]
                                        }
                                        {invoice?.discount_amount}{" "}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="invoice-total-inner">
                                    <p>
                                      Tax ({invoice?.tax}%)
                                      <span>
                                        {
                                          CURRENCY_SYMBOLS[
                                          company?.currency_type
                                          ]
                                        }
                                        {invoice?.tax_amount}{" "}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="invoice-total-footer">
                                    <h4>
                                      Total Amount{" "}
                                      <span>
                                        {
                                          CURRENCY_SYMBOLS[
                                          company?.currency_type
                                          ]
                                        }
                                        {invoice?.final_invoice_amount}
                                      </span>
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="terms-conditions">
                    <div className="row align-items-center justify-content-between">
                      <div className="col-lg-6 col-md-6">
                        <div className="invoice-terms align-center justify-content-start">
                          <span className="invoice-terms-icon bg-white-smoke me-3">
                            <i className="fe fe-file-text" />
                          </span>
                          <div className="invocie-note">
                            <h6>Terms &amp; Conditions</h6>
                            <p className="mb-0">{invoice?.terms}</p>
                          </div>
                        </div>
                        <div className="invoice-terms align-center justify-content-start">
                          <span className="invoice-terms-icon bg-white-smoke me-3">
                            <i className="fe fe-file-minus" />
                          </span>
                          <div className="invocie-note">
                            <h6>Note</h6>
                            <p className="mb-0">{invoice?.notes}</p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="invoice-sign text-end col-lg-6"
                        style={{
                          height: "auto",
                          marginTop: "auto",
                        }}
                      >
                        <span className="d-block">Authorised Sign</span>
                        <p>{invoiceData?.digital_signature_name}</p>
                        <img
                          className="img-fluid d-inline-block"
                          src={invoiceData?.digital_signature_image}
                          alt="sign"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendToCustomerModal invoice={invoice} />
      <AttachmentsModal
        invoiceId={invoice?.id}
        refreshKey={attachmentsRefreshKey}
      />
    </>
  );
};

export default InvoiceDetailsAdmin;

const AttachmentsModal = ({ invoiceId, refreshKey }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [newFile, setNewFile] = useState(null);
  const [newName, setNewName] = useState("");
  const [uploading, setUploading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const basePath = invoiceId ? `/invoice/${invoiceId}/attachments` : null;
  const user = window.CURRENT_USER;

  const fetchItems = () => {
    if (!basePath) return;
    setLoading(true);
    setError(null);
    fetch(`${basePath}/`, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => setItems(data || []))
      .catch((e) => setError(e?.message || "Failed to load attachments"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, refreshKey]);

  const onUpload = (e) => {
    e.preventDefault();
    if (!newFile || !basePath) return;
    const fd = new FormData();
    fd.append("file", newFile);
    if (newName) {
      fd.append("name", newName);
    }
    setUploading(true);
    fetch(`${basePath}/`, {
      method: "POST",
      body: fd,
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((r) => (r.ok ? r.json() : r.json().then((d) => Promise.reject(d))))
      .then(() => {
        setNewFile(null);
        setNewName("");
        fetchItems();
      })
      .catch((e) => setError(e?.detail || "Upload failed"))
      .finally(() => setUploading(false));
  };

  const onReplace = (id, file) => {
    if (!file || !basePath) return;
    const fd = new FormData();
    fd.append("file", file);
    setUpdatingId(id);
    fetch(`${basePath}/${id}/`, {
      method: "PATCH",
      body: fd,
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((r) => (r.ok ? r.json() : r.json().then((d) => Promise.reject(d))))
      .then(() => fetchItems())
      .catch((e) => setError(e?.detail || "Update failed"))
      .finally(() => setUpdatingId(null));
  };

  const onDelete = (id) => {
    if (!basePath) return;
    if (!window.confirm("Delete this attachment?")) return;
    setDeletingId(id);
    fetch(`${basePath}/${id}/`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((r) => {
        if (!r.ok && r.status !== 204) throw new Error("Delete failed");
      })
      .then(() => setItems((prev) => prev.filter((x) => x.id !== id)))
      .catch((e) => setError(e?.message || "Delete failed"))
      .finally(() => setDeletingId(null));
  };

  return (
    <div
      className="modal fade"
      id="attachments_modal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Invoice Attachments</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {error && (
              <div className="alert alert-danger py-2" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={onUpload} className="mb-3">
              <div className="mb-2">
                <label className="form-label">File Name (optional)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter custom name or leave blank to use file name"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setNewFile(e.target.files?.[0] || null)}
                />

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!newFile || uploading}
                >
                  {uploading ? "Uploading..." : "Add"}
                </button>

              </div>
              <div>
                <p>{newFile?.name} </p>
              </div>
            </form>

            {loading ? (
              <p className="text-muted">Loading attachments...</p>
            ) : items?.length ? (
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Uploaded</th>
                      {user?.user_role !== "customer" && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((att) => (
                      <tr key={att.id}>
                        <td>
                          {att.url ? (
                            <a href={att.url} target="_blank" rel="noreferrer">
                              {att.filename || "Attachment"}
                            </a>
                          ) : (
                            att.filename || "Attachment"
                          )}
                        </td>
                        <td>{new Date(att.uploaded_on).toLocaleString()}</td>
                        {user?.user_role !== "customer" && (
                          <td>
                            <label className="btn btn-link p-0 me-2">
                              <input
                                type="file"
                                className="d-none"
                                onChange={(e) =>
                                  onReplace(att.id, e.target.files?.[0])
                                }
                                disabled={updatingId === att.id}
                              />
                              {updatingId === att.id
                                ? "Updating..."
                                : "Replace"}
                            </label>
                            <button
                              className="btn btn-link text-danger p-0"
                              onClick={() => onDelete(att.id)}
                              disabled={deletingId === att.id}
                            >
                              {deletingId === att.id ? "Deleting..." : "Delete"}
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No attachments yet.</p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
